import { Link } from "react-router-dom";
import GradientBg from "@/components/common/GradientBg";
import { BRAND } from "@/branding.config";

const TEAM = [
  { name: "M. Petrov",   role: "Co-founder & CEO", note: "ex-CME low-latency infra" },
  { name: "A. Lindqvist",role: "Co-founder & CTO", note: "ex-Bloomberg network engineering" },
  { name: "S. Nakamura", role: "Head of SRE",      note: "ex-Cloudflare edge team" },
  { name: "R. Okoye",    role: "Head of Customer", note: "ex-DigitalOcean support" },
];

export default function About() {
  return (
    <div className="relative">
      <GradientBg variant="soft" />
      <section className="relative mx-auto max-w-4xl px-6 pt-28 pb-16">
        <div className="text-xs uppercase tracking-[0.2em] text-primary font-bold">About {BRAND.app_name}</div>
        <h1 className="mt-4 text-5xl md:text-6xl font-black tracking-tight">
          Latency is a feature. So is honesty.
        </h1>
        <p className="mt-7 text-lg text-muted-foreground leading-relaxed">
          {BRAND.company_name} was founded in {BRAND.founding_year} by a small team of infrastructure engineers who spent a decade
          building order-routing systems, exchange gateways and market-data feeds. We started {BRAND.short_name} because
          we couldn't find a VPS host that told the truth about performance — so we built one.
        </p>
        <p className="mt-4 text-lg text-muted-foreground leading-relaxed">
          Every plan we sell is one we'd deploy ourselves. Every network edge is measured with the same
          probes we used in trading firms. No overselling. No hidden co-location tax. Just infrastructure
          that behaves exactly the way you'd hope.
        </p>
      </section>

      <section className="mx-auto max-w-6xl px-6 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {[
            { label: "Employees",   value: "42"      },
            { label: "Regions live",value: "12"      },
            { label: "Servers",     value: "1,240+"  },
            { label: "Uptime YTD",  value: "99.998%" },
          ].map((s) => (
            <div key={s.label} className="glass p-7">
              <div className="font-display text-4xl font-black tracking-tight">{s.value}</div>
              <div className="mt-2 text-xs uppercase tracking-widest text-muted-foreground">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-6 pb-24">
        <h2 className="text-3xl font-black tracking-tight mb-10">Leadership</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {TEAM.map((p) => (
            <div key={p.name} className="surface p-7">
              <div
                className="h-14 w-14 rounded-2xl"
                style={{ background: `linear-gradient(135deg, ${BRAND.primary_color}, ${BRAND.accent_color})` }}
              />
              <div className="mt-5 font-bold">{p.name}</div>
              <div className="text-sm text-primary">{p.role}</div>
              <div className="mt-1 text-xs text-muted-foreground">{p.note}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-6 pb-32 text-center">
        <h2 className="text-3xl md:text-4xl font-black tracking-tight">Ready to work with us?</h2>
        <div className="mt-8">
          <Link to="/contact" className="btn-primary px-6 py-3">Get in touch</Link>
        </div>
      </section>
    </div>
  );
}
